export const initTagger = () => {
  if (typeof window === 'undefined') return;

  try {
    // Initialize the lovable tagger if available
    if (window.lovableTagger) {
      window.lovableTagger.init();
      console.log('Lovable tagger initialized');
    }
  } catch (error) {
    console.error('Failed to initialize Lovable tagger:', error);
  }
};

export default initTagger;
